import PatternForm from './PatternForm'
import PatternFormRuleItem from './PatternForm.RuleItem'


const Form = Object.assign(PatternForm, {
    RuleItem: PatternFormRuleItem,
});

export { Form };